import React, { useState, useEffect, useRef } from "react"
import styled from 'styled-components'
import * as easing from 'd3-ease'

import { Spring, animated as a } from 'react-spring/renderprops'

const Path = styled(a.path)`
  fill: none;
  stroke: #FFFFFF;
  stroke-width: 10;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-miterlimit: 10;
`
const AnimatedLine = ({ svg, ...props }) => {
  
  const pathRef = useRef(null)
  const [offset, setOffset] = useState(null);

  useEffect(() => {
    setOffset(pathRef.current.getTotalLength())
  }, [])

  const { id, src, width, height, d } = svg
  const { delay } = props
  return (
    <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px"
      y="0px" viewBox={`0 0 ${width} ${height}`} style={{enableBackground: `new 0 0 ${width} ${height}`}} xmlSpace="preserve">
      <image xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={src} width={width} height={height} mask={`url(#clipmask_back${id})`} />
      <mask id={`clipmask_back${id}`} maskUnits="objectBoundingBox">
        {offset ? (
          <Spring
            config={{ duration: 2000, easing: easing.easeCubicInOut }}
            from={{ dashOffset: offset }}
            to={{ dashOffset: 0 }}
            delay={delay}
          >
            {props => (
              <Path d={d} strokeDashoffset={props.dashOffset} strokeDasharray={offset} />
            )}
          </Spring>
        ) : (
          <Path style={{ opacity: 0 }} ref={pathRef} d={d}/>
        )}
      </mask>
    </svg>
  )
}


export default AnimatedLine